import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import SubjectAmendmentRegister from '../../modules/subject/components/SubjectAmendmentRegister';

const StartSubjectAmendments = () => (
  <>
    <TitleHeader title="Subject Amendment" />
    <ContentTemplate>
      <SubjectAmendmentRegister />
    </ContentTemplate>
  </>
);

export default StartSubjectAmendments;
